module.exports = __webpack_public_path__ + "static/img/11.717b10f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/zh/11.png
// module id = kDas
// module chunks = 0